import React, { useEffect, useState } from 'react';
import './CalcCeChart.css';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
    ChartOptions,
} from "chart.js";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-moment';
import { ChartCe } from './CalcCeData';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
);

type Props = {
    charCe: ChartCe,
}
const defaultData: ChartCe = {
    // dt: [],
    // dtTime: [],
    chartCe: [],
    chartCeAvg1: [],
    chartCeAvg2: [],
    chartCeAvg3: [],
    chartCeAvg4: [],
}

// CSSカスタムプロパティを取得
const getCSSVariableValue = (variableName: string) => 
    getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();

export const CalcCeChart: React.FC<Props> = ({charCe}) => {

    const data = {

        datasets: [
            {
                label: 'CE',
                data: [
                    ...charCe.chartCe                
                ],
                borderColor: getCSSVariableValue('--AlkaNexus-BLUE'),
                pointRadius : 1,
                showLine: false,
            },
            {
                label: 'CE av. 24H',
                data: [
                    ...charCe.chartCeAvg1                   
                ],
                borderColor: getCSSVariableValue('--AlkaNexus-LIGHT-BLUE'),
                pointRadius : 0,
            },
            {
                label: 'CE av. 48H',
                data: [
                    ...charCe.chartCeAvg2                   
                ],
                borderColor: getCSSVariableValue('--AlkaNexus-GREEN'),
                pointRadius : 0,
            },
            {
                label: 'CE av. 72H',
                data: [
                    ...charCe.chartCeAvg3                   
                ],
                borderColor: getCSSVariableValue('--AlkaNexus-ORANGE'),
                pointRadius : 0,
            },
            {
                label: 'CE av. 96H',
                data: [
                    ...charCe.chartCeAvg4                   
                ],
                borderColor: getCSSVariableValue('--AlkaNexus-PURPLE'),
                pointRadius : 0,
            },
        ],
    };

    const options: ChartOptions<'line'> = {
        responsive: false,
        scales: {
            'xAxes':
                {
                    title: {
                        display: true,
                        text: 'Day And Time',
                    },
                    type: 'time',
                    time: {
                        // minuteだと、3カ月分のファイルでエラー
                        // hourでも最初と最後のデータで10年以上の差異があるとエラー
                        unit: 'hour',
                        displayFormats: {
                            hour: 'YYYY-MM-DD hh:mm',
                        },
                    }
                },
            'yAxes':
                {
                    title: {
                        display: true,
                        text: 'Current Efficiency [%]',
                    },
                },
        },
        
    };

    return (
        <div className="CalcCeChart_content">
            <Line data={data} options={options} width={800} height={350}/>
        </div>
    );
};
